import React, { useContext, useState } from 'react'
import { PlatformUserContext, UserReviewStatus } from '../../providers/user-provider/user-provider'
import { useService } from '@pushly/aqe/lib/hooks'
import { AppService } from '../../services'
import { Affix, Alert, Button, Modal } from 'antd'
import G2IconColor from '../icons/g2-icon-color'
import './g2-review-banner.scss'
import { CloseOutlined } from '@ant-design/icons'
import { DomainDto } from '../../dtos/domain'

export const G2ReviewBanner = ({ domain, mobileView }: { domain: DomainDto; mobileView?: boolean }) => {
    const userCtx = useContext(PlatformUserContext)

    const appSvc = useService(AppService)
    const [reviewModalOpen, setReviewModalOpen] = useState(false)
    const [alertVisible, setAlertVisible] = useState(false)

    if (!userCtx.authenticated) return null

    const domainHasReviewFlag = domain.flags?.includes('FEAT_G2_IN_APP_REVIEW')
    const canShowReviewItem =
        domainHasReviewFlag && !userCtx.user.isInternalUser && userCtx.reviewState.status !== UserReviewStatus.COMPLETED

    React.useEffect(() => {
        if (userCtx.reviewState.status === UserReviewStatus.PENDING) {
            setAlertVisible(true)
        }

        return () => setAlertVisible(false)
    }, [])

    if (!canShowReviewItem) {
        return null
    }

    const handleClose = (status: UserReviewStatus) => {
        setAlertVisible(false)

        appSvc.setG2ReviewStatus(userCtx.user.id, { status })
        userCtx.assignUser!((prev) => ({
            ...prev,
            reviewState: {
                ...('reviewState' in prev ? prev.reviewState : {}),
                status,
            },
        }))
    }

    return (
        <div
            className={`g2-review-alert-container alert-is-${alertVisible ? 'visible' : 'hidden'} ${
                mobileView ? 'mv' : ''
            }`}
        >
            {userCtx.reviewState.status === UserReviewStatus.PENDING && (
                <Alert
                    className={`${alertVisible ? 'g2-show-transition' : 'g2-hide-transition'} ${
                        mobileView ? 'mv' : ''
                    }`}
                    type="info"
                    banner={true}
                    showIcon={false}
                    icon={<G2IconColor className="g2-icon" />}
                    message={
                        <div className="g2-review-alert-message-container">
                            <div
                                className="g2-review-alert-message"
                                onClick={() => {
                                    handleClose(UserReviewStatus.ACKNOWLEDGED)
                                    setReviewModalOpen(true)
                                }}
                            >
                                <div>
                                    <G2IconColor className="g2-icon" />
                                </div>
                                <div>
                                    Write a G2 Review and earn a&nbsp;
                                    <span className="g2-review-alert-link">$50 Amazon Gift Card!</span>
                                </div>
                            </div>
                            <div
                                className="g2-review-alert-close-icon"
                                onClick={() => handleClose(UserReviewStatus.DISMISSED)}
                            >
                                <CloseOutlined />
                            </div>
                        </div>
                    }
                />
            )}

            <Modal
                getContainer={appSvc.getContentContainer}
                className={`g2-review-modal ${mobileView ? 'mv' : ''}`}
                open={reviewModalOpen}
                onCancel={() => {
                    setReviewModalOpen(false)
                }}
                closable={!mobileView}
                destroyOnClose={true}
                footer={null}
            >
                <iframe src={userCtx.reviewState.url} />
                {mobileView && (
                    <Button onClick={() => setReviewModalOpen(false)} className="g2-review-modal-close-icon">
                        <CloseOutlined />
                    </Button>
                )}
            </Modal>
        </div>
    )
}
